import React, { useState } from 'react';
import Sidebar from './Sidebar';
import DataPageHeader from './DataPageHeader';

function Layout({ selectedOrg, onSelectOrg, userRole, children }) {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(true);
  const [mobileDrawerOpen, setMobileDrawerOpen] = useState(false);

  return (
    <div style={{ minHeight: '100vh', width: '100%' }}>
      <style>{`
        .op-layout-content {
          min-height: 100vh;
          background: #f5f6f8;
          transition: margin-left 0.22s ease;
        }
        @media (min-width: 992px) {
          /* Sidebar width + a small gap so the floating toggle button
             (which pokes out ~12px past the sidebar's right edge) has
             room to render fully instead of being clipped by the header. */
          .op-layout-content { margin-left: 256px; }
          .op-layout-content.sidebar-collapsed { margin-left: 92px; }
        }
      `}</style>
      <Sidebar
        selectedOrg={selectedOrg}
        userRole={userRole}
        collapsed={sidebarCollapsed}
        onToggle={() => setSidebarCollapsed((c) => !c)}
        mobileOpen={mobileDrawerOpen}
        onMobileClose={() => setMobileDrawerOpen(false)}
      />
      <div className={`op-layout-content ${sidebarCollapsed ? 'sidebar-collapsed' : ''}`}>
        <DataPageHeader
          selectedOrg={selectedOrg}
          onSelectOrg={onSelectOrg}
          userRole={userRole}
          onMobileMenuClick={() => setMobileDrawerOpen(true)}
        />
        <main className="main-content">{children}</main>
      </div>
    </div>
  );
}

export default Layout;